import { api } from "@/api/axios.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";
import { ApiJobRole, ApiJobRoleFilter, ApiJobRoleSavePayload } from "@/types/job-role.types.ts";

export const apiJobRoles = {
  search: async function (filter: ApiJobRoleFilter, signal: AbortSignal) {
    return api.post<ApiPagedData<ApiJobRole>>("/api/v1/job-roles/search", filter, signal);
  },
  getById: async function (id: number) {
    return api.get<ApiJobRole>(`/api/v1/job-roles/${id}`);
  },
  getByIds: async function (ids: number[], signal?: AbortSignal) {
    return api.post<Pick<ApiJobRole, "id" | "title" | "is_archived">[]>(
      "/api/v1/job-roles/get-by-ids",
      { job_role_ids: ids },
      signal
    );
  },
  create: async function (payload: ApiJobRoleSavePayload) {
    return api.post<ApiJobRole>("/api/v1/job-roles", payload);
  },
  update: async function (id: number, payload: ApiJobRoleSavePayload) {
    return api.put<ApiJobRole>(`/api/v1/job-roles/${id}`, payload);
  },
  delete: async function (id: number) {
    return api.delete(`/api/v1/job-roles/${id}`);
  },
};
